import {
  COMMON_IS_LOADING,
  COMMON_ALERT_OPEN,
  COMMON_ALERT_CLOSE,
  COMMON_FETH_DATA,
  COMMON_FETCH_DATA_SUCCESS,
  COMMON_FETCH_DATA_ERROR,
  COMMON_FETCH_COUNTRIES_SUCCESS 
} from "../actions/commonActions";

const commonState = {
  is_loading: true,
  error: null,
  alert: {
    open: false,
    type: 'error',
    message: ''
  },
  nationalities: {},
  countries: null,
  eyes: null,
  hair: null,
  yesno: null,
  disease_type: null,
  legal_drug: null,
  skin_affections: null,
  possible_affections: null,
  allergies_product_list: null,
  health_and_care_products: null,
  hair_removal_zones: null,
  hair_removal_products_list: null,
  preferred_test_types: null,
  preferred_application_zones: null,
  health_problems: null,
  derma_affections: null,
  skin_types: null,
  skin_nature: null,
  skin_characteristics: null,
  cellulite_type: null,
  hand_skin_nature: null,
  consumer_usual_products: null
};

export default function (state = commonState, action) {
  switch (action.type) {
    case COMMON_IS_LOADING:
      return {...state, is_loading: action.is_loading}
    case COMMON_ALERT_OPEN:
      return {...state, alert: action.alert}
    case COMMON_ALERT_CLOSE:
      return {...state, alert: action.alert}
    case COMMON_FETCH_DATA_SUCCESS:
      return {...state, ...action.payload}
    case COMMON_FETCH_DATA_ERROR:
      return {error: action.payload};
    case COMMON_FETCH_COUNTRIES_SUCCESS:
      return {...state, countries: action.payload}
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/commonReducer.js